import * as React from 'react';
import './SolutionCard.pcss';
import {DashboardSolution} from "../../data/entities/DashboardSolution";
import {CardButton} from "./CardButton";
import LiveEventData, {LiveEvent} from "../../data/LiveEventData";
import {observer} from "mobx-react";
import {LiveBadge} from "../widgets/LiveBadge";

interface Props {
  solution:DashboardSolution;
  onClick:(solution:DashboardSolution)=>void;
}

export const SolutionCard = observer((props:Props) => {
  function handleClick() {
    props.onClick(props.solution);
  }

  const liveEvent = LiveEventData.firstLiveEventForSolutionId(props.solution._id);
  
  if(props.solution.registered || props.solution.autoRegister ) {
    return <Registered
      liveEvent={liveEvent}
      solution={props.solution}
      buttonAction={handleClick}
    />;
  } else {
    if(props.solution.maxRegistrationsReached) {
      return <MaxRegistrationsReached
          liveEvent={liveEvent}
          solution={props.solution}
          buttonAction={handleClick}
      />;

    } else {
      return <RegisterNow
          liveEvent={liveEvent}
          solution={props.solution}
          buttonAction={handleClick}
      />;
    }
  }
});

interface _Props {
  solution:DashboardSolution;
  buttonAction:()=>void;
  liveEvent:LiveEvent|undefined;
}


const MaxRegistrationsReached = (props:_Props) =>
    <div className={"solutionCard registerNow"}>
      <div><img src={props.solution.photoObject.icon} alt={""} aria-hidden /></div>
      <div>
        <div>
          <h3 className={'level3'}>{props.solution.name}</h3>
          <p>{props.solution.cardSubTitle}</p>
        </div>
        <CardButton buttonAction={props.buttonAction} buttonLabel={"Registration Full"} />
      </div>
    </div>
;

const RegisterNow = (props:_Props) =>
  <div className={"solutionCard registerNow"}>
    <div><img src={props.solution.photoObject.icon} alt={""} aria-hidden /></div>
    <div>
      <div>
        <h3 className={'level3'}>{props.solution.name}</h3>
        {(props.liveEvent && props.liveEvent.live) ?
          <>
            <p className={"sc-status live"}>{props.liveEvent.startedAt}</p>
            <LiveBadge />
          </>
          :
          <>
            {('challenge'===props.solution.type || 'health fair'===props.solution.type) ?
              <p>{props.solution.isOpen ? "Open for participation" : props.solution.beginsOn}</p>
              :
              <p>{props.solution.cardSubTitle}</p>
            }
          </>
        }
      </div>
      <CardButton
        buttonAction={props.buttonAction}
        buttonLabel={"Register now"}
        ariaButtonLabel={`Register now for ${props.solution.name}`}

      />
    </div>
  </div>
;

const Registered = (props:_Props) =>
  <div className={"solutionCard"}>
    <div><img src={props.solution.photoObject.smallPhoto} alt={""} aria-hidden /></div>
    <div>
      <div>
        <h3 className={'level3'}>{props.solution.name}</h3>
        <p>{props.solution.cardSubTitle}</p>
        {(props.liveEvent && props.liveEvent.live) ?
          <>
            <p className={"sc-status live"}>{props.liveEvent.startedAt}</p>
            <LiveBadge />
          </>
          :
          <>
            {('challenge'===props.solution.type || 'health fair'===props.solution.type) &&
              <p className={"sc-status"}>{props.solution.isOpen ? "Open for participation" : props.solution.beginsOn}</p>
            }
          </>
        }
      </div>
      <CardButton
        buttonAction={props.buttonAction}
        buttonLabel={`Enter`}
        ariaButtonLabel={`Enter ${props.solution.name}`}
        hideLabel={false}
      />
      {/*<CardButton buttonAction={props.buttonAction} buttonLabel={`Enter ${props.solution.type}`} hideLabel={false} />*/}
    </div>
  </div>
;
